import { Helmet } from "react-helmet-async";
import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { useSearchParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LoadingBar from "../LoadingBar";
import ProfileWithBackButtonHeader from "../header/ProfileWithBackButtonHeader";
import SectionHeaderBlogs from "../header/SectionHeaderBlogs";
import "./blogs.css";

const BlogDetail = () => {
  const { t, i18n } = useTranslation();
  const [params] = useSearchParams();
  const blogId = params.get("id");

  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  // const { pathname, search } = useLocation(); // ไม่ได้ใช้ Comment ออกได้ครับ

useEffect(() => {
  const fetchBlog = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BIGC_BIGLINE_API_URL}/blogs/blog_detail`,
        { blog_id: blogId, language: i18n.language.toUpperCase() },
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_BIGC_BIGLINE_API_KEY,
          },
        }
      );

      const result = response.data?.data || response.data;
      setBlog(result || null);
    } catch (error) {
      console.error("Error fetching blog:", error);
      setBlog(null);
    } finally {
      setLoading(false);
    }
  };

  if (!blogId) {
    setBlog(null);
    setLoading(false); // ✅ สำคัญมาก กันค้างโหลดบนมือถือ
    return;
  }

  fetchBlog();
}, [blogId, i18n.language]);

if (window.location.hostname.includes("stg") && "serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
  if (window.caches) {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
  }
}


  // --- Helpers ---
  const stripHtml = (html = "") => {
    if (typeof html !== "string") return "";
    return html.replace(/<[^>]*>?/gm, "").trim();
  };
  
  const clamp = (s = "", n = 180) =>
    s.length > n ? s.slice(0, n - 1) + "…" : s;

  // --- Utility เพื่อดึงค่า Text ที่อาจซ้อนอยู่ใน .rendered หรืออยู่ชั้นนอก ---
  const getRenderedContent = (field) => {
    if (!field) return "";
    return field.rendered || field || "";
  };

  // --- SEO & META Logic ---
  const currentUrl =
  typeof window !== "undefined" ? window.location.href : "";

const metaData = useMemo(() => {
  const rawTitle = getRenderedContent(blog?.title);
  const title = rawTitle ? stripHtml(rawTitle) : "Big C Digital Web Connect";

  const rawExcerpt = getRenderedContent(blog?.excerpt);
  const rawContent = getRenderedContent(blog?.content);

  const description = clamp(
    rawExcerpt ? stripHtml(rawExcerpt) : stripHtml(rawContent)
  );

  const image = blog?.image
  return { title, description, image };
}, [blog]);


  return ( 
    <>
      <Helmet>
        <title>{metaData.title}</title>
        <meta name="description" content={metaData.description} />
        <link rel="canonical" href={currentUrl} />

        {/* Facebook Open Graph */}
        <meta property="og:type" content="article" />
        <meta property="og:title" content={metaData.title} />
        <meta property="og:description" content={metaData.description} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:image" content={metaData.image} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metaData.title} />
        <meta name="twitter:description" content={metaData.description} />
        <meta name="twitter:image" content={metaData.image} />

        {blog?.date && (
          <meta
            property="article:published_time"
            content={new Date(blog.date).toISOString()}
          />
        )}
      </Helmet>

      <ProfileWithBackButtonHeader />
      
      {loading ? (
        <LoadingBar loading={loading} label="Loading..." />
      ) : (
        <div className="bg-[#f6f6f6] w-full px-5 xs:px-2 pb-6">
          <SectionHeaderBlogs
            className="py-4"
            name={t("blogs")}
            eventSection={true}
            seniorLayout={false}
          />

          {!loading && blog ? (
            <div className="bg-white rounded-xl p-4 shadow">
              {/* Title: รองรับทั้ง .rendered และ string ปกติ */}
              <h1
                className="text-xl font-semibold mb-2 text-left"
                dangerouslySetInnerHTML={{ __html: getRenderedContent(blog?.title) }}
              />
              
              <div className="text-xs text-gray-500 text-right mb-4">
                publish:{" "}
                {blog?.date
                  ? new Date(blog.date).toLocaleDateString("th-TH", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })
                  : "-"}
              </div>

              {blog?.image && (
                <img
                  src={blog.image}
                  alt={metaData.title} 
                  className="w-full h-auto rounded mb-4"
                />
              )}

              {/* Content: รองรับทั้ง .rendered และ string ปกติ */}
              <div
                className="prose prose-neutral max-w-full text-left blog-content-container"
                dangerouslySetInnerHTML={{
                  __html: getRenderedContent(blog?.content),
                }}
              />
            </div>
          ) : !loading && !blog ? (
            <div className="text-center text-gray-500 mt-8">
              {t("not_found") || "Blog not found"}
            </div>
          ) : null}
        </div>
      )}
    </>
  );
};

export default BlogDetail;



// import { Helmet } from "react-helmet-async";
// import React, { useEffect, useState, useMemo } from "react";
// import axios from "axios";
// import { useSearchParams, useLocation } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import LoadingBar from "../LoadingBar";
// import ProfileWithBackButtonHeader from "../header/ProfileWithBackButtonHeader";
// import SectionHeaderBlogs from "../header/SectionHeaderBlogs";
// import "./blogs.css";

// const BlogDetail = () => {
//   const { t, i18n } = useTranslation();
//   const [params] = useSearchParams();
//   const blogId = params.get("id");

//   const [blog, setBlog] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const { pathname, search } = useLocation();

//   useEffect(() => {
//     const fetchBlog = async () => {
//       setLoading(true);
//       try {
//         const response = await axios.post(
//           `${process.env.REACT_APP_BIGC_BIGLINE_API_URL}/blogs/blog_detail`,
//           {
//             blog_id: blogId,
//             language: i18n.language.toUpperCase(),
//           },
//           {
//             headers: {
//               "Content-Type": "application/json",
//               "x-api-key": process.env.REACT_APP_BIGC_BIGLINE_API_KEY,
//             },
//           }
//         );
//         setBlog(response.data || null);
//       } catch (error) {
//         console.error("Error fetching blog:", error);
//         setBlog(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (blogId) fetchBlog();
//   }, [blogId, i18n.language]);

//   // --- Helpers ---
//   const stripHtml = (html = "") => html.replace(/<[^>]*>?/gm, "").trim();
//   const clamp = (s = "", n = 180) =>
//     s.length > n ? s.slice(0, n - 1) + "…" : s;

//   // --- SEO & META Logic ---
//   const currentUrl = window.location.href;
  
//   // คำนวณค่า Meta Data (ใช้ useMemo เพื่อ Performance)
//   const metaData = useMemo(() => {
//     const title = blog?.title?.rendered
//       ? stripHtml(blog.title.rendered)
//       : "Big C Digital Web Connect"; // Default Title

//     const description = clamp(
//       blog?.excerpt?.rendered
//         ? stripHtml(blog.excerpt.rendered)
//         : stripHtml(blog?.content?.rendered || "") || "ติดตามข่าวสารและโปรโมชั่นจาก Big C" // Default Desc
//     );

//     let image = "https://linebc.bigc.co.th/images/og-default.jpg"; // Default Image (ควรมีรูปนี้จริงๆ บน Server)
//     if (blog?.image && typeof blog.image === "string" && blog.image.startsWith("http")) {
//       image = blog.image;
//     }

//     return { title, description, image };
//   }, [blog]);

//   return ( 
//     <>
//       {/* ย้าย Helmet มาไว้นอกเงื่อนไข blog && (...) เพื่อให้มีค่าเสมอ */}
//       <Helmet>
//         <title>{metaData.title}</title>
//         <meta name="description" content={metaData.description} />
//         <link rel="canonical" href={currentUrl} />

//         {/* Facebook Open Graph */}
//         <meta property="og:type" content="article" />
//         <meta property="og:title" content={metaData.title} />
//         <meta property="og:description" content={metaData.description} />
//         <meta property="og:url" content={currentUrl} />
//         <meta property="og:image" content={metaData.image} />
//         <meta property="og:image:width" content="1200" />
//         <meta property="og:image:height" content="630" />

//         {/* Twitter Card */}
//         <meta name="twitter:card" content="summary_large_image" />
//         <meta name="twitter:title" content={metaData.title} />
//         <meta name="twitter:description" content={metaData.description} />
//         <meta name="twitter:image" content={metaData.image} />

//         {blog?.date && (
//           <meta
//             property="article:published_time"
//             content={new Date(blog.date).toISOString()}
//           />
//         )}
//       </Helmet>

//       <ProfileWithBackButtonHeader />
//       {loading ? (
//         <LoadingBar loading={loading} label="Loading..." />
//       ) : (
//         <div className="bg-[#f6f6f6] w-full px-5 xs:px-2 pb-6">
//           <SectionHeaderBlogs
//             className="py-4"
//             name={t("blogs")}
//             eventSection={true}
//             seniorLayout={false}
//           />

//           {!loading && blog ? (
//             <div className="bg-white rounded-xl p-4 shadow">
//               <h1
//                 className="text-xl font-semibold mb-2 text-left"
//                 dangerouslySetInnerHTML={{ __html: blog.title.rendered }}
//               />
//               <div className="text-xs text-gray-500 text-right mb-4">
//                 publish:{" "}
//                 {blog?.date
//                   ? new Date(blog.date).toLocaleDateString("th-TH", {
//                       year: "numeric",
//                       month: "long",
//                       day: "numeric",
//                     })
//                   : "-"}
//               </div>
//               {blog?.image && (
//                 <img
//                   src={blog.image}
//                   alt={stripHtml(blog.title.rendered || "")}
//                   className="w-full h-auto rounded mb-4"
//                 />
//               )}
//               <div
//                 className="prose prose-neutral max-w-full text-left"
//                 dangerouslySetInnerHTML={{
//                   __html: blog?.content?.rendered || "",
//                 }}
//               />
//             </div>
//           ) : !loading && !blog ? (
//             <div className="text-center text-gray-500 mt-8">
//               {t("not_found") || "Blog not found"}
//             </div>
//           ) : null}
//         </div>
//       )}
//     </>
//   );
// };

// export default BlogDetail;